export class ColorUtils {
  public static format(value: Number) {
    let color = value.toString(16);
    const count = 6 - color.length;
    for (let i = 0; i < count; i++) {
      color = '0' + color;
    }
    return color;
  }
}
